const layout = {
  header: {
    changeView: {
      toasts: {
        success: 'Bereich erfolgreich geändert',
        failure: 'Unerwarteter Fehler aufgetreten',
      },
    },
  },

  sideBar: {
    menu: {
      home: {
        title: 'Privat',
      },
      parents: {
        title: 'Eltern',
      },
      trips: {
        title: 'Fahrten',
        children: {
          trips: 'Fahrten',
          timeline: 'Zeitleiste',
          feedbacks: 'Feedbacks',
        },
      },
      jobs: {
        title: 'Buchungen',
        children: {
          jobs: 'Buchungen',
          calendar: 'Kalender',
          passengers: 'Fahrgäste',
          students: 'Schüler',
          employees: 'Mitarbeiter',
          profiles: 'Profil',
          parents: 'Eltern',
          caregivers: 'Pflegekräfte',
        },
      },
      drivers: {
        title: 'Fahrer',
        children: {
          drivers: 'Fahrer',
          onlineDrivers: 'Online Fahrer',
          driverShifts: 'Fahrerschichten',
          driverShiftsTemplates: 'Schichtvorlagen',
          livemap: 'Live-Karte',
        },
      },
      vehicles: {
        title: 'Fahrzeuge',
      },
      integrations: {
        title: 'Integrationen',
      },
      automations: {
        title: 'Automatisierungen',
      },
      reports: {
        title: 'Berichte',
      },
      more: {
        title: 'Mehr',
        children: {
          areas: 'Zonen',
          attributes: 'Eigenschaften',
          blacklist: 'Karten-Blacklist',
          extraServices: 'Zusatzleistungen',
          fares: 'Tarife',
          holidays: 'Feiertage',
          locations: 'Standorte',
          permissions: 'Rollen und Berechtigungen',
          profiles: 'Profil',
          rates: 'Preise',
          services: 'Leistungen',
          shifts: 'Schichten',
          shuttles: 'Shuttlebusse',
          sites: 'Bereiche',
          suppliers: 'Anbieter',
          settings: 'Systemeinstellungen',
          uploadData: 'Daten hochladen',
          users: 'Benutzer',
          apiKeys: 'API-Schlüssel',
          customRules: 'Benutzerdefinierte Regeln',
          facilities: 'Einrichtungen',
          roiSimulation: 'ROI-Simulation',
        },
      },
    },
    settings: {
      myProfile: {
        button: 'Mein Profil',
      },
      languages: {
        button: 'Sprachen',
      },
      themes: {
        button: 'Theme ändern',
        options: {
          light: 'Hell',
          dark: 'Dunkel',
        },
      },
      logout: 'Abmelden',
    },
  },

  footer: {
    poweredBy: 'Powered by',
    moovex: 'Moovex',
  },

  asideQueue: {
    headerQueue: 'Warteschlange',
    empty: 'Keine Reservierungen in der Warteschlange gefunden',
    btnRemove: 'Aus der Warteschlange entfernen',
    btnAssign: 'Zur Fahrt bewegen',
  },
};

export default layout;
